var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subtitle"},[_c('div',{staticClass:"above-title"},[_vm._t("above-title")],2),_vm._m(0),_c('div',{staticClass:"under-title"},[_vm._t("under-title")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cut-off"},[_c('b'),_c('img',{attrs:{"src":require("assets/img/common/subtitle_cutoff.png"),"alt":""}}),_c('b')])
}]

export { render, staticRenderFns }